import React, { createContext, useContext, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { auth } from './firebaseConfig';
import { onAuthStateChanged, signOut } from 'firebase/auth'
import { getUserToken, getUserDetails } from "../api/user";
import * as Sentry from "@sentry/browser";

const AuthContext = createContext()

export const useAuth = () => useContext(AuthContext)

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null)
  const [accessToken, setAccessToken] = useState(null);
  const [activeUser, setActiveUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [youtubeTokenLoading, setYoutubeTokenLoading] = useState(true);
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user)
      if (user) {
        Sentry.setUser({ id: user.uid });
        setYoutubeTokenLoading(true);
        getUserToken(user)
          .then((token) => {
            setAccessToken(token);
          })
          .catch((error) => {
            Sentry.withScope((scope) => {
              scope.setTag("area", "auth-context");
              scope.setTag("auth_context", "youtube-token-load");
              scope.setUser({ id: user.uid });
              Sentry.captureException(error);
            });
            setAccessToken(null);
          })
          .finally(() => {
            setYoutubeTokenLoading(false);
          });
        getUserDetails(user)
          .then((userDetails) => {
            setActiveUser(userDetails);
            Sentry.setUser({
              id: user.uid,
              username: userDetails?.profileInfo?.username || undefined,
            });
            Sentry.setTag("user_role", userDetails?.profileInfo?.role || "unknown");
            Sentry.setTag("main_game", userDetails?.profileInfo?.mainGame || "unknown");
          })
          .catch((error) => {
            Sentry.withScope((scope) => {
              scope.setTag("area", "auth-context");
              scope.setTag("auth_context", "active-user-load");
              scope.setUser({ id: user.uid });
              Sentry.captureException(error);
            });
            setActiveUser(null);
          })
          .finally(() => setAuthLoading(false));
      } else {
        Sentry.setUser(null);
        Sentry.setTag("user_role", "anonymous");
        Sentry.setTag("main_game", "unknown");
        setAccessToken(null);
        setActiveUser(null);
        setAuthLoading(false);
        setYoutubeTokenLoading(false);
      }
    })
    return () => unsubscribe()
  }, [])

  const logout = () => {
    signOut(auth).then(() => {
    }).catch((error) => {
      console.error('Logout Error:', error)
      Sentry.withScope((scope) => {
        scope.setTag("area", "auth-context");
        scope.setTag("auth_context", "logout");
        Sentry.captureException(error);
      });
    })
  }
  

  const value = {
    currentUser,
    logout,
    accessToken,
    setAccessToken,
    activeUser,
    authLoading,
    youtubeTokenLoading,
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired
}
